import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, Component } from 'react';
import classNames from 'classnames';
import TextareaAutosize from 'react-textarea-autosize';
import { idFromName } from 'libs/utils/html';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** @deprecated Use @vinted/web-ui version of InputTextArea instead or provide reasons why you must use this one */
class DeprecatedInputTextarea extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      inputValue: this.props.value || ''
    });

    _defineProperty(this, "handleChange", event => {
      const {
        onChange,
        uncontrolled
      } = this.props;
      if (!uncontrolled) this.setState({
        inputValue: event.target.value || ''
      });
      if (onChange) onChange(event);
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setState({
        inputValue: this.props.value || ''
      });
    }
  }

  render() {
    const {
      name,
      validation,
      title,
      required,
      disabled,
      minLength,
      maxLength,
      icon,
      placeholder,
      styling,
      theme,
      rows,
      maxRows,
      forwardedRef,
      uncontrolled,
      onKeyPress,
      onKeyDown,
      onFocus,
      onInputClick
    } = this.props;
    const inputClass = classNames('c-input', {
      ["c-input--".concat(String(styling))]: styling !== undefined
    }, {
      ["c-input--".concat(String(theme))]: theme !== undefined
    });
    return /*#__PURE__*/_jsxs("label", {
      htmlFor: name,
      className: inputClass,
      children: [title && /*#__PURE__*/_jsx("div", {
        className: "c-input__title",
        children: title
      }), /*#__PURE__*/_jsxs("div", {
        className: "c-input__content",
        children: [/*#__PURE__*/_jsx(TextareaAutosize, {
          className: "c-input__value",
          name: name,
          id: idFromName(name),
          value: uncontrolled ? undefined : this.state.inputValue,
          required: required,
          disabled: disabled,
          minLength: minLength,
          maxLength: maxLength,
          placeholder: placeholder,
          onChange: this.handleChange,
          onClick: onInputClick,
          onKeyPress: onKeyPress,
          onKeyDown: onKeyDown,
          onFocus: onFocus,
          minRows: rows,
          ref: forwardedRef,
          maxRows: maxRows
        }), icon && /*#__PURE__*/_jsx("div", {
          className: "c-input__icon",
          children: icon
        })]
      }), validation && /*#__PURE__*/_jsx("div", {
        className: "c-input__note",
        children: validation
      })]
    });
  }

}

_defineProperty(DeprecatedInputTextarea, "defaultProps", {
  required: false,
  disabled: false,
  rows: 5
});

const DeprecatedInputTextareaWithForwardedRef = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(DeprecatedInputTextarea, _objectSpread({
  forwardedRef: ref
}, props)));
export default DeprecatedInputTextareaWithForwardedRef;